exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2VMsDISazXAAMjGAz0QE1L{display:-webkit-box;display:-ms-flexbox;display:flex;display:-webkit-flex;max-width:510px}html[dir] ._2VMsDISazXAAMjGAz0QE1L{margin:30px}", ""]);

// exports
exports.locals = {
	"divContainer": "_2VMsDISazXAAMjGAz0QE1L"
};